export const isDefined = (v: any) => typeof v !== "undefined"

export const isSomeDefined = (...args: any) => [...args].some(isDefined)

export const isNull = (v: any) => typeof v === "object" && !v
